import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { I18NextPipe } from 'angular-i18next';
import { TemplateProfile } from '../../models';

export interface AddTemplateProfileDialogData {
  templateProfiles: TemplateProfile[];
}

@Component({
  selector: 'app-add-template-profile-dialog',
  templateUrl: './add-template-profile-dialog.component.html',
  styleUrls: ['./add-template-profile-dialog.component.scss'],
  standalone: false
})
export class AddTemplateProfileDialogComponent implements OnInit {
  selectedTemplateProfiles: Set<number> = new Set();

  constructor(
    public dialogRef: MatDialogRef<AddTemplateProfileDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AddTemplateProfileDialogData,
    private i18n: I18NextPipe
  ) {}

  ngOnInit(): void {
  }

  onTemplateSelect(template: TemplateProfile): void {
    if (this.selectedTemplateProfiles.has(template.id)) {
      this.selectedTemplateProfiles.delete(template.id);
    } else {
      this.selectedTemplateProfiles.add(template.id);
    }
  }

  isSelected(template: TemplateProfile): boolean {
    return this.selectedTemplateProfiles.has(template.id);
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onAdd(): void {
    if (this.selectedTemplateProfiles.size > 0) {
      const selectedTemplates = this.data.templateProfiles.filter(tp =>
        this.selectedTemplateProfiles.has(tp.id)
      );
      this.dialogRef.close({ selectedTemplates: selectedTemplates });
    }
  }

  canAdd(): boolean {
    return this.selectedTemplateProfiles.size > 0;
  }

  getSelectedCount(): number {
    return this.selectedTemplateProfiles.size;
  }
}

